import { render, staticRenderFns } from "./FavouriteNotification.vue?vue&type=template&id=35de86ac&"
import script from "./FavouriteNotification.vue?vue&type=script&lang=ts&"
export * from "./FavouriteNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports